import { Component, Input } from '@angular/core';

@Component({
  selector: 'hf-loading-spinner',
  templateUrl: './loading-spinner.component.html'
})
export class LoadingSpinnerComponent {
  @Input()
  public ariaLabel = 'Loading...';
}
